import axios from '../api'
import { isNoUser, apiToken } from '@/common/js/assist'

//团体门票预约日历
const calendar = () =>
	axios(
		'/teamticket/calendar', {
			p: 'w'
		}
	)
//相关文字显示
const textTip = () =>
	axios(
		'/teamticket/text_tip', {
			p: 'w'
		}
	)
//团体登录
const teamLogin = (username = '', password = '') =>
	axios(
		'/teamusers/login', {
			p: "w",
			username,
			password
		}, 'POST'
	)
//团体用户信息
const teamUserInfo = () =>
	axios(
		'/teamusers/info', {
			p: "w",
			api_token: apiToken()
		}, 'GET', {
			type: 'team'
		}
	)
//团体预约记录
const orderRecord = (
		url,
		obj = {}
	) =>
	axios(
		url, { ...{
				p: 'w',
				api_token: apiToken(),
				limit: 5
			},
			...obj
		}
	)
//团体预约详情
const orderDetail = (torder_id = '', contact_phone = '', contact_idcard = '') =>
	axios(
		isNoUser() ? '/my/teamticketorder/detail_nouser' : '/my/teamticketorder/detail', {
			p: 'w',
			api_token: apiToken(),
			torder_id,
			contact_phone,
			contact_idcard
		}
	)
//团体门票详情
const ticketDetail = (td_tp_id = '') =>
	axios(
		'/teamticket/detail', {
			p: 'w',
			api_token: apiToken(),
			td_tp_id
		}
	)
//团体名单验证
const checkList = (listexcel = '') =>
	axios(
		isNoUser() ? '/teamticketorder/listcheck_nouser' : '/teamticketorder/listcheck', {
			p: 'w',
			api_token: apiToken(),
			td_id: sessionStorage.getItem('team_td_id'),
			is_get_errorlist: 1,
			listexcel
		},
		'POST', {
			formData: true,
			type: 'team'
		}
	)
//预约团体门票
const applyTicket = (obj = {}, formData = false) =>
	axios(
		isNoUser() ? '/teamticketorder_nouser' : '/teamticketorder', { ...{
				p: 'w',
				api_token: apiToken(),
				td_tp_id: sessionStorage.getItem('team_td_tp_id')
			},
			...obj
		},
		'POST', {
			formData: formData
		}
	)
//团体预约名单详情
const list = (torder_id = '', contact_phone = '', contact_idcard = '') =>
	axios(
		isNoUser() ? '/my/teamticketorder/detail_list_nouser' : '/my/teamticketorder/detail_list', {
			p: 'w',
			api_token: apiToken(),
			torder_id,
			contact_phone,
			contact_idcard
		}
	)
//团体类型列表
const typeList = () =>
	axios(
		'/teamusers/teamtype', {
			p: 'w'
		}
	)
//团体注册
const register = (obj = {}) =>
	axios(
		'/teamusers/register', { ...{
				p: 'w'
			},
			...obj
		},
		'POST', {
			formData: true
		}
	)
//团体修改信息-重新提交审核
const infoRetrial = (obj = {}) =>
	axios(
		'/teamusers/re_apply', { ...{
				p: 'w',
				api_token: apiToken(),
			},
			...obj
		},
		'POST', {
			formData: true
		}
	)
//更新团体名单
const updateList = (obj = {}) =>
	axios(
		isNoUser() ? '/my/teamticketorder/detail_list_update_nouser' : '/my/teamticketorder/detail_list_update', { ...{
				p: 'w',
				api_token: apiToken()
			},
			...obj
		},
		'POST'
	)
//团体取消订单
const cancelOrder = (torder_id = '', contact_phone = '', contact_idcard = '', order_sn = '') =>
	axios(
		isNoUser() ? '/teamticketorder/cancel_nouser' : '/teamticketorder/cancel', {
			p: 'w',
			api_token: apiToken(),
			torder_id,
			contact_phone,
			contact_idcard,
			order_sn
		},
		'POST'
	)
//门票订单状态数组
const orderStatus = () =>
	axios(
		'/ticket/order_status_search', {
			p: 'w',
			order_type: 2
		}
	)
//团体修改密码
const changeMyPsd = (obj = {}) =>
	axios(
		'/teamusers/password', { ...{
				p: 'w'
			},
			...obj
		},
		'POST'
	)
//团体退票
const refund = (obj = {}) =>
	axios(
		isNoUser() ? '/teamticketorder/refund_nouser' : '/teamticketorder/refund', { ...{
				p: 'w',
				api_token: apiToken()
			},
			...obj
		},
		'POST'
	)
export default {
	calendar,
	textTip,
	teamLogin,
	teamUserInfo,
	orderRecord,
	orderDetail,
	ticketDetail,
	checkList,
	applyTicket,
	list,
	typeList,
	register,
	infoRetrial,
	updateList,
	cancelOrder,
	orderStatus,
	changeMyPsd,
	refund
}


// WEBPACK FOOTER //
// ./src/http/modules/team.js